import React from 'react';
import { Box } from '@mui/material';
interface FormTextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    error?: boolean;
    helperText?: string | undefined;
}

const FormTextField = React.forwardRef<HTMLInputElement, FormTextFieldProps>(({ label, error, helperText, onChange, onBlur, name, value, ...props }, ref) => {
    return (
        <Box style={{
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 1,
            display: 'inline-flex',
            position: 'relative',
        }}>
            <Box style={{
                alignSelf: 'stretch',
                marginBottom: 0
            }}>
                <div style={{
                    color: '#1A1A1A',
                    fontSize: 12,
                    fontFamily: 'Helvetica Neue LT Std',
                    fontWeight: '400',
                    // textTransform: 'capitalize',
                    lineHeight: '16px',
                    letterSpacing: 0.70,
                    wordWrap: 'break-word',
                    position: 'absolute',
                    top: -7.5,
                    left: 10,
                    background: "white",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                    display: "block"
                }}>
                    {label}
                </div>
            </Box>
            <Box style={{
                alignSelf: 'stretch',
                height: 38,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 4,
                border: '1px #012A52 solid',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                display: 'flex'
            }}>
                <Box style={{
                    alignSelf: 'stretch',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 8,
                    display: 'inline-flex',
                    height: 36,
                }}>
                    <input
                        style={{
                            flex: '1 1 0',
                            border: 'none',
                            fontSize: '16px',
                            fontFamily: 'Roboto',
                            fontWeight: '400',
                            boxSizing: 'border-box',
                            outline: 'none',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'transparent',
                        }}
                        ref={ref}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        {...props}
                    />
                </Box>
            </Box>
            {error && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{helperText}</div>}
        </Box>
    );
});

export default FormTextField;